<template>
  <div class="audio_page" :style="{'height': contentHeight + 'px'}">
    <div class="top_banner">
      <img class="top_logo" src="../../assets/tfsharelogo.png" alt="">
      <div class="middel-info">
        <div>铁粉生活</div>
        <div class="s_text">湖南广电旗下唯一本地生活服务APP</div>
      </div>
      <div id="btn_open">打开APP</div>
    </div>
    <div style="margin-top: 55px;" v-if="!isEmpty">
      <div class="audio_info">
        <div class="name">{{ info.name }}</div>
        <div class="head_img">
          <img :src="info.imageUrl" alt="">
        </div>
        <div class="audio">
          <audio :src="info.url" controls style="height: 50px; width: 300px;"></audio>
        </div>
      </div>
      <div class="detail">
        <div class="content" v-html="info.descirb">
        </div>
      </div>
      <!-- 评论 -->
      <div class="comment" v-if="commentList.length > 0">
        <div class="comment_title">全部评论</div>
          <div class="comment_item" v-for="(item, index) in commentList" :key="index">
            <div class="comment_userImg">
              <img :src="item.headImageUrl" alt="" />
            </div>
            <div class="comment_user">
              <div class="comment_userInfo">
                <div class="comment_user_name">{{ item.nickName }}</div>
                <div class="comment_time">{{ item.createTime | timeFormat }}</div>
              </div>
              <div class="comment_content">{{ item.text }}</div>
              <div class="comment_content_number" @click="showAllComment(item)" v-if="item.children && item.children.length > 0">
                {{ item.children.length }}条回复
                <span><Icon type="ios-arrow-forward" color="black"></Icon></span>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div v-else class="empty_container" :style="{'height': contentHeight + 'px'}">视频已被删除</div>

    <Drawer ref="drawer" placement="bottom" class="drawer" :closable="false" v-model="drawerShow" :height="contentHeight - 200">
      <div slot="header">
        <div align="center" class="drawer_title">回复（{{ commentInfo.children.length }}）</div>
        <div class="comment_item main">
          <div class="comment_userImg">
            <img :src="commentInfo.headImageUrl" alt="" />
          </div>
          <div class="comment_user">
            <div class="comment_userInfo">
              <div class="comment_user_name">{{ commentInfo.nickName }}</div>
              <div class="comment_time">{{ commentInfo.createTime | timeFormat }}</div>
            </div>
            <div class="comment_content txt_ellipsis">{{ commentInfo.text }}</div>
          </div>
        </div>
      </div>
      <div class="comment" v-if="commentInfo.children.length > 0">
        <div class="comment_title">全部回复</div>
        <div class="comment_item" v-for="(item, index) in commentInfo.children" :key="index">
          <div class="comment_userImg">
            <img :src="item.headImageUrl" alt="" />
          </div>
          <div class="comment_user">
            <div class="comment_userInfo">
              <div class="comment_user_name">{{ item.nickName }}</div>
              <div class="comment_time">{{ item.createTime | timeFormat }}</div>
            </div>
            <div class="comment_content">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </Drawer>

    <Spin fix size="large" v-if="loading"></Spin>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: "audioPage",
  components: {},
  data() {
    return {
      loading: true,
      isEmpty: false,
      drawerShow: false,
      albumDetailId: '',
      info: {},
      commentList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      commentInfo: {
        children: []
      },
      contentHeight: document.documentElement.clientHeight
    };
  },
  filters: {
    timeFormat: function (value) {
      if (!value) return ''
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  mounted() {
    let param = this.$route.query
    this.albumDetailId = param.id

    // linkType(0:音频)
    var data = XInstall.parseUrlParams();
    new XInstall({
      appKey : "mq81ipn",
      buttonId: [
        { idName: 'btn_open', params: {linkType: 0, linkId: param.id} }
      ]
    }, data);

    this.getAudioInfo()
    let dom = document.querySelector('.audio_page')
    let that = this
    dom.addEventListener('scroll', function () {
      // scrollDistance 为零时滚动到底部
      const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight
      if (scrollDistance <= 1) { // 等于0证明已经到底，可以请求接口
        if (that.commentList.length >= that.total) {
          return
        }
        that.pageIndex = that.pageIndex + 1
        that.getAlbumDetailComment()
      }
    })
  },
  methods: {
    getAudioInfo() {
      let that = this
      that.loading = true
      this.$http.get('/albumDetail/open/getAlbumDetail', {
        albumDetailId: this.albumDetailId
      }, function (data) {
        that.info = data.data
        that.isEmpty = false
        that.getAlbumDetailComment()
        that.loading = false
      }, function () {
        that.isEmpty = true
        that.loading = false
      })
    },
    getAlbumDetailComment() {
      let that = this
      this.$http.post('/albumDetail/comment/open/getCommentList', {
        albumDetailId: this.albumDetailId,
        parentId: 0,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }, function (data) {
        if (that.pageIndex == 1) {
          that.commentList = data.data.records
          that.total = data.data.total
        } else {
          that.commentList = that.commentList.concat(data.data.records)
        }
      }, function () {
      }, 'json')
    },
    showAllComment(item) {
      this.commentInfo = item
      this.drawerShow = true
      let that = this
      this.$nextTick(function () {
        that.$refs.drawer.$refs.content.lastChild.scrollTop = 0
      })
    }
  }
};
</script>
<style scoped>
.audio_page {
  background: #eee;
  position: relative;
  overflow-y: auto;
}
.top_banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  background: rgb(255, 255, 255);
  padding: 6px;
  color: #000;
  border-bottom: 1px solid #eee;
}
.top_logo {
  width: 40px;
  border-radius: 6px;
}
.middel-info {
  flex: 1;
  margin-left: 6px;
  font-size: 16px;
}
.s_text {
  font-size: 12px;
  color: rgba(153,153,153,1);
}
#btn_open {
  background-color: #3C74F2;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 20px;
  color: #fff;
}
.audio_info {
  background-color: #fff;
}
.name {
  font-size: 18px;
  text-align: center;
  padding: 20px 10px;
}
.head_img {
  text-align: center;
}
.head_img img {
  width: 100%;
  margin: auto;
}
.audio {
  padding: 15px;
  text-align: center;
}
.detail {
  background: white;
  margin-top: 10px;
}
.detail_title {
  font-size: 16px;
  font-weight: 500;
  padding: 10px;
}
.content {
  padding: 10px;
}
.content >>> img {
  width: 100%;
}
.comment {
  background-color: #fff;
  margin-top: 10px;
}
/* 评论 */
.comment {
  padding: 10px;
}
.comment_title {
  font-size: 16px;
  font-weight: 500;
}
.comment_userImg img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: gray;
}
.comment_item {
  display: flex;
  flex-direction: row;
  margin: 15px 0;
}
.comment_user {
  margin-left: 10px;
}
.comment_user_name {
  font-size: 15px;
}
.comment_time {
  color: #ccc;
}
.comment_content {
  margin: 10px 0;
}
.comment_content.txt_ellipsis {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.comment_content_number {
  margin-top: 10px;
  color: #ccbe0f;
}
.drawer_title {
  font-size: 16px;
  font-weight: bold;
}
.drawer >>> .comment_user {
  line-height: 1.5;
}
.drawer >>> .comment_item.main {
  margin-bottom: 0;
}
.drawer >>> .comment_content {
  margin: 0;
}
.drawer >>> .comment {
  margin-top: 0;
  padding: 0;
}
.drawer >>> .ivu-drawer-body {
  height: calc(100% - 128px);
}
.empty_container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/audio.vue